import React, { Component } from 'react'
import CreateDelivery from '../components/CreateDelivery'

class Month extends Component{
  constructor(){
    super();
    this.state = {
      firstCarts: [],
      carts: [],
      customers: null,
      total: null,
      firstQuantity: null,
      quantity: null,
      createStatus: false,
      textarea: ""
    }

    this.toggleCreateDelivery = this.toggleCreateDelivery.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleProductChange = this.handleProductChange.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.getText = this.getText.bind(this)
  }

  toggleCreateDelivery() {
    this.setState(prevState => ({createStatus: !prevState.createStatus}))
  }

  handleEmailChange(event) {
    const value = event.target.value.toLowerCase()
    if (value.length > 0) {
      const searchResult = this.state.firstCarts.filter(cart =>
        cart.cart__user__email.toLowerCase().includes(value)
      )
      this.setState({carts: searchResult})
    } else {
      this.setState(prevState => ({carts: prevState.firstCarts}))
    }
  }

  handleProductChange(event) {
    const value = event.target.value.toLowerCase()
    let newQuantity = 0
    if (value.length > 0) {
      const searchResult = this.state.firstCarts.filter(cart => {
        if (cart.product__title.toLowerCase().includes(value)) {
          newQuantity += cart.quantity
          return cart
        }
      })
      this.setState({
        carts: searchResult,
        quantity: newQuantity
      })
    } else {
      this.setState(prevState => ({
        carts: prevState.firstCarts,
        quantity: prevState.firstQuantity
      }))
    }
  }

  handleNameChange(event) {
    const value = event.target.value.toLowerCase()
    if (value.length > 0) {
      const searchResult = this.state.firstCarts.filter(cart => {
        const customerName = `${cart.cart__user__first_name} ${cart.cart__user__last_name}`
        if (customerName.toLowerCase().includes(value)){
          return cart
        }
      })
      if (searchResult[0] !== undefined) {
        this.setState({carts: searchResult})
      } else {
        this.setState({carts: []})
      }
    } else {
      this.setState(prevState => ({carts: prevState.firstCarts}))
    }
  }

  getText() {
    const month_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/generate-text/${month_id}`, {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(res => {
            this.setState({textarea: res})
          })
        } else {
          console.log("Server Error!");
        }
      })
  }

  componentDidMount() {
    const month_id = this.props.match.params.id
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/month/${month_id}`, {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(res => {
            this.setState({
              firstCarts: res.carts,
              carts: res.carts,
              customers: res.customers,
              total: res.total,
              firstQuantity: res.quantity,
              quantity: res.quantity
            })
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  render() {
    const month_id = this.props.match.params.id
    const months = [
        "Januari",
        "Februari",
        "Mars",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "Augusti",
        "September",
        "October",
        "November",
        "December",
    ]

    return(
      <div className="Admin-Month">
        {
          this.state.createStatus
          ?
          <div className="CreateDelivery-overlay">
            <CreateDelivery
              toggleCreateDelivery={this.toggleCreateDelivery}
              monthId={month_id}/>
          </div>
          :
          null
        }
        <h1>{months[month_id - 1]}</h1>
        <div className="d-flex">
          <h4>Antal kunder: {this.state.customers}</h4>
          {
            this.state.total
            ?
            <h4>Totalsumma: {this.state.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}kr</h4>
            :
            null
          }
        </div>
        <div className="Products-body">
          <table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Namn</th>
                <th>Product</th>
                <th className="t-c">Quantity ({this.state.quantity})</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-r-20">
                  <input
                    type="text"
                    className="table-input"
                    placeholder="Email"
                    onChange={this.handleEmailChange} />
                </td>
                <td className="p-r-20">
                  <input
                    type="text"
                    className="table-input"
                    placeholder="Name"
                    onChange={this.handleNameChange}/>
                </td>
                <td className="p-r-20">
                  <input
                    type="text"
                    className="table-input"
                    placeholder="Product"
                    onChange={this.handleProductChange} />
                </td>
                <td>
                </td>
              </tr>
              {
                this.state.carts.map(cart => {
                  return(
                    <tr key={cart.id}>
                      <td>{cart.cart__user__email}</td>
                      <td>{cart.cart__user__delivery_first_name} {cart.cart__user__delivery_last_name}</td>
                      <td>{cart.product__title}</td>
                      <td className="t-c">{cart.quantity}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <h3>Textfältet</h3>
        <button onClick={this.getText}>Skapa text</button>
        <textarea 
          className="textarea" 
          value={this.state.textarea} 
          onChange={(event) => this.setState({textarea: event.target.value})}
          >
        </textarea>
      </div>
    )
  }
}

export default Month



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Month.jsx